/**
 * service
 */
import taskmanAxios from '../helpers/axios'
import {corBusinessAxios} from 'cor-business'
/**
 * const
 */
import {API_USER_LIST_URL, API_USER_AVATAR_URL, API_RBAC_ROLES_URL, API_INVITE_URL} from "../constants/api.constant";

export default class UserService {
    static async getUsers(params?: {
        skip?: number;
        limit?: number;
        search?: string;
        workspace_id?: number;
        project_id?: number;
    }) {
        return await taskmanAxios.get(API_USER_LIST_URL, { params })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async getRoles() {
        return await taskmanAxios.get(API_RBAC_ROLES_URL)
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }

    static async getPhoto() {
        return await taskmanAxios.get(API_USER_AVATAR_URL, { responseType: 'blob' })
            .then(response => URL.createObjectURL(response.data))
            .catch(e => Promise.reject(e));
    }

    static async uploadAvatar(file: Blob, fileName: string = 'avatar.png') {
        const formData = new FormData()
        formData.append('file', file, fileName)

        return await taskmanAxios.put(API_USER_AVATAR_URL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }


    static async inviteUser(data: {
        email: string;
        role: string;
        first_name: string;
        last_name: string;
        phone_number: string;
        expires_in_days?: number;
        workspace_id?: number;
    }) {
        return await corBusinessAxios.post(API_INVITE_URL, {
            ...data,
            service_payload: {
                workspace_id: data.workspace_id
            }
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e));
    }
}
